import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-ab-banner',
  standalone: true,
  imports: [],
  templateUrl: './ab-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ab-banner.component.scss'
})
export class AbBannerComponent {

}
